import { render, staticRenderFns } from "./FooterMenusApps.vue?vue&type=template&id=42b1677a"
import script from "./FooterMenusApps.vue?vue&type=script&lang=js"
export * from "./FooterMenusApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports